"use client";

import React, { useState } from "react";
import RegisterComponent from "./RegisterComponent";
import LoginComponent from "./LoginComponent";

interface AuthModalProps {
  mode: "register" | "login";
  onToggle: () => void;
  onLoginSuccess?: () => void;
  pddMode?: boolean;
}

const AuthModal: React.FC<AuthModalProps> = ({
  mode,
  onToggle,
  onLoginSuccess,
  pddMode,
}) => {
  const [registrationSuccessMessage, setRegistrationSuccessMessage] = useState<string | null>(null);

  return (
    < >
      {mode === "register" ? (
        <RegisterComponent
          onToggle={onToggle}
          onCompanyRegisterSuccess={() => {
            setRegistrationSuccessMessage(
              "Регистрация прошла успешно. Теперь вы можете войти в систему."
            );
            onToggle();
          }}
        />
      ) : (
        <LoginComponent
          onToggle={onToggle}
          onLoginSuccess={onLoginSuccess}
          externalSuccessMessage={registrationSuccessMessage}
          pddMode={pddMode}
        />
      )}
    </>
  );
};

export default AuthModal;
